<template>
  <div>
    <div class="row">
      <div class="col">
        <h5>Abstract Presentation Selection</h5>
        <div>
            Please note that due to limited space in the programme, it may not be possible to offer all accepted abstracts their preferred presentation type. In this instance we may offer an alternative presentation type.
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="alert alert-info mb-1">
          <div class="row">
            <div class="col-1 d-flex">
              <icon :icon="['fad', 'exclamation']" class="my-auto fa-2x"/>
            </div>
            <div class="col">
              Please note that you <span class="text-danger">may not change your presentation preference later</span> in the
              abstract submission process.<br>
              If you would like to use a different option, you will have to create a new
              abstract.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Oral presentation</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(1)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">e-Poster presentation</h5>
          </div>
            <div class="card-footer bg-transparent border-0 d-flex">
              <button class="btn btn-success mx-auto" v-on:click="newAbstract(2)">Select</button>
            </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">Video presentation (maximum 8 minutes)</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(3)">Select</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions} from 'vuex'

  export default {
    name: "AbstractType",
    data() {
      return {
        submitted: false,
      };
    },
    methods: {
      ...mapActions([
        'CREATE_ABSTRACT', 'UPDATE_REFERENCE'
      ]),
      newAbstract(type) {
        if (this.submitted === true) {
          return false;
        }
        this.submitted = true;
          let template = {
            "user_id": this.user.id,
            "type_id": type,
            "setting_submission_id": 1,
            "reference_number": this.getSettings(1).reference_number,
            "content": {},
            "status_id": 1
          };
        this.CREATE_ABSTRACT(template).then((response) => {
          this.$noty.success(this.wording[0].notify.save_success);
          this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(1).id)
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.save_not_success);
        });
      }
    },
    computed: {
      ...mapState([
        'wording', 'user'
      ]),
      ...mapGetters([
        'getSettings', 'getFirstCurrentPage'
      ]),
    },
  }
</script>

<style scoped>

</style>